/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import draftApi from '../../../api/draft.api';
import { createFOAsyncThunk } from '../../helpers/thunk.helpers';

/**
 * Thunk used to remove the attachments of a Bio Material when it gets deleted.
 */
export const removeAttachmentsById = createFOAsyncThunk(
  'bioMaterials/removeAttachments',
  async ({ submissionId, attachmentIds }) => {
    const requests = attachmentIds.map(id => draftApi.deleteAttachment(submissionId, id));
    await Promise.all(requests);
  },
  {
    showApplicationLoading: true,
  },
);
